import { render, staticRenderFns } from "./CertificateCard.component.vue?vue&type=template&id=2f6e8cba"
import script from "./CertificateCard.component.vue?vue&type=script&lang=ts"
export * from "./CertificateCard.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports